import axios from 'axios';
import shortid from 'shortid';

// in production or on PHP server window.WP will be available
let WP = window.WP;

// fetches WP object and store it in local storage
export const fetchWP = (lang='no', redirect='/') => {
    axios.get(process.env.REACT_APP_GET_WP_ENDPOINT, {
        params: { 
            lang: lang,
            stamp: shortid.generate(),
        }
    }).then(resp => {
        window.localStorage.setItem('WP-'+process.env.REACT_APP_THEME, JSON.stringify(resp.data));
        window.location.replace(redirect);
    }); 
}

// on react dev server window.WP is not available so we need to get it manually
if(!WP) {

    // lets see if WP is already available in local storage before fetching it
    WP = JSON.parse(window.localStorage.getItem('WP-'+process.env.REACT_APP_THEME));

    // if WP is not availale in local storage we need to get it
    if(!WP && process.env.NODE_ENV === 'development') {
        let lang = window.location.href.substring(1, 3);
        if(lang !== 'no' && lang !== 'en') {
            lang = 'no';
        }
        fetchWP(lang);
    }
  
}

export default WP;